<script setup lang="ts">
import { computed } from 'vue'

import type { BadgeProps } from './types'
import { badgeVariants } from './variants'
import { clsx } from 'clsx'
import { Primitive } from 'radix-vue'

const props = defineProps<BadgeProps>()

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})
</script>

<template>
  <Primitive
    data-slot="badge"
    :class="clsx(badgeVariants({ variant, position }), props.class)"
    v-bind="delegatedProps"
  >
    <slot />
  </Primitive>
</template>
